import React from 'react';

import { FormattedMessage } from 'react-intl';
import NewsCard from './news-card.component.js';
import { PrimaryButton } from '../../../components/ui-toolkit/buttons.js';

const NewsGrid = ({ news, loadMore, handleMore }) => {
	if (!news || news.length === 0) {
		return <h1>No news!</h1>;
	}

	const col1 = [];
	const col2 = [];
	const col3 = [];
	let index = 2;

	col3.push(news[1]);
	while (index < news.length) {
		col3.push(news[index]);

		if (index + 1 >= news.length) break;
		col1.push(news[index + 1]);

		if (index + 2 >= news.length) break;
		col2.push(news[index + 2]);

		index += 3;
	}

	return (
		<div className="container container-fluid">
			<div className="row">
				<div className="col-xs-12 col-sm-6 col-md-8">
					<div className="container">
						<div className="row">
							<div className="col-xs-12 col-md-12" key={news[0].id}>
								<NewsCard
									title={news[0].title}
									image={news[0].image}
									date={news[0].date}
									slug={news[0].slug}
									extraClasses="first"
								/>
							</div>
							<div className="col-xs-12 col-md-12">
								<div className="container">
									<div className="row">
										<div className="col-xs-12 col-md-6">
											<div className="container col-1">
												<div className="row">
													{col1.map(item => (
														<div className="col-xs-12" key={item.id}>
															<NewsCard
																title={item.title}
																image={item.image}
																date={item.date}
																slug={item.slug}
															/>
														</div>
													))}
												</div>
											</div>
										</div>
										<div className="col-xs-12 col-md-6">
											<div className="container">
												<div className="row col-2">
													{col2.map(item => (
														<div key={item.id} className="col-xs-12">
															<NewsCard
																title={item.title}
																image={item.image}
																date={item.date}
																slug={item.slug}
															/>
														</div>
													))}
													{loadMore && (
														<div className="col-xs-12 center-xs middle-xs load-more-button-desktop">
															<PrimaryButton onclick={handleMore}>
																<FormattedMessage id="news.load_more_results" />
															</PrimaryButton>
														</div>
													)}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-xs-12 col-sm-6 col-md-4">
					<div className="container">
						<div className="row col-3">
							{col3.map(item => (
								<div key={item.slug} className="col-xs-12">
									<NewsCard
										title={item.title}
										image={item.image}
										date={item.date}
										slug={item.slug}
									/>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			{loadMore && (
				<div className="col-xs-12 center-xs middle-xs load-more-button-mobile">
					<PrimaryButton onclick={handleMore}>
						<FormattedMessage id="news.load_more_results" />
					</PrimaryButton>
				</div>
			)}
		</div>
	);
};

export default NewsGrid;
